module.exports = __webpack_public_path__ + "img/chat-forum.b5484572.png";